module.exports = __webpack_public_path__ + "img/logo-dpd.d83f5ef5.png";